import type { StepStatus } from '../types'

export function StatusPill({ status }: { status: StepStatus | string }) {
  const tone = status === 'Terminé' ? 'done' : status === 'En attente' || status === 'Bloqué' ? 'waiting' : status === 'En cours' ? 'active' : status === 'À confirmer' ? 'uncertain' : 'future'
  const help: Record<string, string> = {
    'Non commencé': 'Cette étape n’a pas encore démarré.',
    'En cours': 'Cette étape est actuellement traitée.',
    'En attente': 'Une réponse ou une action extérieure est attendue.',
    'À confirmer': 'L’information doit encore être vérifiée pour ce projet.',
    'Terminé': 'Cette étape est considérée comme achevée.',
    'Bloqué': 'Cette étape ne peut pas avancer sans lever un obstacle.',
  }
  return <span className={`status-pill ${tone}`} title={help[status] ?? status}>{status}</span>
}
